<div class="cb-margin flex-col">
    <div class="flex-row">
        @if (productCards) {
            @for (productCard of productCards; track productCard) {
                <cb-item-usage-summary-card
                    class="flex"
                    [label]="productCard.label"
                    [value]="productCard.value"
                >
                </cb-item-usage-summary-card>
            }
        }
    </div>
</div>
